import React from 'react';
import { CampaignType, GamicType } from './types';
import { formatLocalDate } from '@/utils/FormateLocalDate';
import RemoteFile from '@/helper/RemoteFile';

interface Props {
  campaign: CampaignType;
  gamic: GamicType;
}

const CampaignDetail: React.FC<Props> = ({ campaign, gamic }) => {

    function formatLocation(loc: any): string {
    const city = loc.target_level === 'place' ? loc.name : null;
    const subregion =
      loc.target_level === 'region' || loc.target_level === 'place'
        ? loc.region_name
        : null;
    const country =
      loc.target_level === 'country' ||
      loc.target_level === 'region' ||
      loc.target_level === 'place'
        ? loc.country_name
        : null;

    return [city, subregion, country].filter(Boolean).join(', ');
  }

  return (
    <div className='flex  p-6 space-x-[32px]'>
      {/* Left side - Campaign Details */}
      <div className='flex-1 h-[716px] w-[716px] bg-[#f5f5f5] p-6 rounded-[16px]'>
        <h2 className='text-2xl font-bold mb-4'>Campaign Details</h2>
        <div className='space-y-4'>
          <div className='border-b py-2'>
            <h4 className='text-[16px] text-gray-500 uppercase'>Game Name</h4>
            <p className='mt-1 text-[20px] text-gray-700'>{gamic.title}</p>
          </div>

          <div className='border-b py-2'>
            <h4 className='text-[16px] text-gray-500 uppercase'>
              Gender Target
            </h4>
            <p className='mt-1 text-[20px] text-gray-700'>
              {campaign.audience_details.gender.join(', ')}
            </p>
          </div>

          <div className='border-b py-2'>
            <h4 className='text-[16px] text-gray-500 uppercase'>Age Target</h4>
            <p className='mt-1 text-[20px] text-gray-700'>{`${campaign.audience_details.min_age} - ${campaign.audience_details.max_age}`}</p>
          </div>

          <div className='border-b py-2'>
            <h4 className='text-[16px] text-gray-500 uppercase'>Location</h4>
             <div className='flex flex-wrap gap-2'>
              {campaign.audience_details.audience_locations
                .map((loc) => {
                  return (
                    <span
                      className='px-3 py-1 bg-white rounded-full text-sm text-gray-800 shadow-sm'
                    >
                      {formatLocation(loc)}
                    </span>
                  );
                })}
             </div>
          </div>

          <div className='border-b py-2'>
            <h4 className='text-[16px] text-gray-500 uppercase'>Date Range</h4>
            <p className='mt-1 text-[20px] text-gray-700'>
              {`${formatLocalDate(campaign.start_date)} - ${formatLocalDate(campaign.end_date)}`}
            </p>
          </div>

          <div className='border-b py-2'>
            <h4 className='text-[16px] text-gray-500 uppercase'>Budget</h4>
            <p className='mt-1 text-[20px] text-gray-700'>
              $ {campaign.total_budget}
            </p>
          </div>
        </div>
      </div>

      {/* Right side - Live Preview */}
      <div className=' flex-1 flex flex-col justify-center items- h-[716px] w-[716px] bg-[#f5f5f5] p-6 rounded-[16px]'>
        <h2 className='text-2xl font-bold mb-4'>Live Preview</h2>
          <RemoteFile
            className='h-full w-full'
            keyPath={gamic.file_url}
            key={gamic.title}
          />
      </div>
    </div>
  );
};

export default CampaignDetail;
